import { useEffect, useRef } from "react";
import styles from "./box.module.css";
import { Player } from "@lordicon/react";

const NewBox = ({ num, icon, title, description, className }) => {
  const playerRef1 = useRef(null);

  const handleComplete = () => {
    setTimeout(() => {
      if (playerRef1?.current?.playFromBeginning) {
        playerRef1.current.playFromBeginning();
      }
    }, 2500);
  };

  const handleReady = () => {
    if (playerRef1?.current?.playFromBeginning) {
      playerRef1.current.playFromBeginning();
    }
  };

  useEffect(() => {
    if (icon && playerRef1?.current) {
      const timer = setTimeout(() => {
        if (playerRef1?.current?.playFromBeginning) {
          playerRef1.current.playFromBeginning();
        }
      }, 100);
      return () => clearTimeout(timer);
    }
  }, [icon]);

  return (
    <div className={`${styles.NewBox}${className ? ` ${className}` : ''}`}>
      {num && <div className={styles.num}>{num}</div>}
      <div className={styles.row}>
        {icon && (
          <div className={styles.icon}>
            <Player
              icon={icon}
              ref={playerRef1}
              size="100%"
              loop={true}
              onComplete={handleComplete}
              onReady={handleReady}
              colorize="rgba(255,255,255,0.9)"
            />
          </div>
        )}
        <div className={styles.title}>{title}</div>
      </div>
      <div className={styles.description}>{description}</div>
    </div>
  );
};

export default NewBox;
